// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__yYGW8","col":"styles_col__27XD3"};